import { useState } from "react";
import axios from "axios";
import api from "../services/axiosInstance";
import { useNotification } from './NotifPopup';
import { backendPort } from "../components/Fungsiku";
import { ShowPic } from "../components/ShowPic";

export function PageKonten9_Pict({
  attachments,
  setAttachments,
  bisaInput,
  bisaHapus = true,
  uploadInputClassName = "",
  invalidCaptionIndexes = [],
  onCaptionChange = () => {},
}) {

  const { showNotif } = useNotification();  
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewFiles, setPreviewFiles] = useState([]);

  const resolveAttachmentUrl = (item) => {
    const urlFromPath = String(item?.path || item?.url || "").trim();
    const urlFromFileName = (typeof item?.file === "string" && String(item.file).trim())
      ? `${backendPort}/uploads/dokumen/${String(item.file).trim()}`
      : "";
    return item?.preview
      || (item?.file instanceof File ? URL.createObjectURL(item.file) : null)
      || (urlFromPath ? (urlFromPath.startsWith("http") ? urlFromPath : `${backendPort}${urlFromPath}`) : null)
      || (urlFromFileName || null);
  };
  // Tambah file
  const handleAddFile = (e) => {
    if(!bisaInput) {
      showNotif("error", "Silahkan isi data ban.");
      return;
    };

    const files = Array.from(e.target.files);

    const validFiles = files.filter(file => {
      if (file.size > MAX_FILE_SIZE) {
        showNotif('error',`${file.name} melebihi 5MB`);
        return false;
      }
      return true;
    });

    const mapped = validFiles.map(file => ({
      file,
      caption: "",
      preview: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null,
      type: file.type
    }));

    setAttachments(prev => [...prev, ...mapped]);
    onCaptionChange();
  };

  // Ubah caption
  const handleCaptionChange = (index, value) => {
    if (value.length > 30) return;

    const updated = [...attachments];
    updated[index].caption = value;
    setAttachments(updated);
    onCaptionChange(index, value);
  };

  // Hapus
  const handleDelete = (index) => {
    const target = attachments?.[index];
    const isLampiranBaru = target?.file instanceof File;
    if (!bisaHapus && !isLampiranBaru) return;
    const updated = attachments.filter((_, i) => i !== index);
    setAttachments(updated);
    onCaptionChange();
  };

  // Show file
  const handleShow = (item) => {
    const url = resolveAttachmentUrl(item);
    if (!url) return;
    setPreviewFiles([{
      url,
      name: String(item?.name || item?.file?.name || "").trim(),
      caption: String(item?.caption || "").trim() || "Dokumen",
    }]);
    setShowPreviewModal(true);
  };
  /*
  const handleUpload = async () => {
    if (attachments.length === 0) {
      alert("Tidak ada file");
      return;
    }

    const formData = new FormData();

    attachments.forEach((item, i) => {
      formData.append("files", item.file);
      formData.append(`captions[${i}]`, item.caption);
    });

    try {
      setUploading(true);
      setUploadProgress(0);

      await api.post(`${backendPort}/api/main/upload_pic`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        }
      });

      alert("Upload berhasil");
      setAttachments([]);
    } catch (err) {
      alert("Upload gagal");
    } finally {
      setUploading(false);
    }
  };*/

  return (
    <div className="mt-2 mb-2 px-2 py-2">
      
      {/* GRID */}
      <div className="d-flex flex-column gap-2">
        {attachments.map((item, index) => (
          (() => {
            const isLampiranBaru = item?.file instanceof File;
            const canDeleteItem = Boolean(bisaHapus || isLampiranBaru);
            const isCaptionInvalid = invalidCaptionIndexes.includes(index);
            return (
          <div
            key={index}
            className="d-flex align-items-center justify-content-between gap-2 px-2 py-2 rounded border border-light-subtle bg-white"
          >
            <button
              type="button"
              disabled={!bisaInput}
              className="btn btn-link p-0 text-decoration-none d-flex align-items-center justify-content-center rounded-circle overflow-hidden border"
              style={{ width: "50px", height: "50px", minWidth: "50px", background: "#f8fafc" }}
              onClick={() => handleShow(item)}
              title="Lihat Dokumen"
            >
              {(
                ((item?.type || "").startsWith("image/") && item.preview)
                || (String(item?.path || item?.url || "").match(/\.(png|jpe?g|webp|gif|bmp|svg)($|\?)/i))
              ) ? (
                <img
                  src={resolveAttachmentUrl(item) || ""}
                  alt="preview"
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                  }}
                />
              ) : (
                <i
                  className="fa fa-file-pdf text-danger"
                  style={{ fontSize: "20px" }}
                ></i>
              )}
            </button>

            <div className="flex-grow-1 text-start">
              <input
                type="text"
                disabled={!bisaInput}
                className={`form-control form-control-sm mb-1 ${isCaptionInvalid ? "bg-warning-subtle border-warning" : ""} ${String(uploadInputClassName || "").trim() === 'dashboard-supervisi-upload-input' ? 'dashboard-supervisi-upload-caption' : ''}`}
                placeholder="Keterangan dokumen/foto.."
                value={item.caption}
                onChange={(e) =>
                    handleCaptionChange(index, e.target.value)
                }
              />
              {/*<small className="text-muted fs-sm">
                {item.caption.length}/30
              </small>*/}
            </div>

            <div className="d-flex align-items-center">
              <button
                type="button"
                disabled={!bisaInput || !canDeleteItem}
                className="btn btn-outline-danger btn-sm"
                onClick={() => handleDelete(index)}
                aria-label={`Hapus lampiran ${index + 1}`}
                title="Hapus Dokumen"
              >
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
            );
          })()
        ))}
      </div>

      {/* INPUT */}
      <div className="mt-3 mb-3">
        <input
          type="file"
          multiple
          disabled={!bisaInput}
          accept="image/*,.pdf"
          className={`form-control ${String(uploadInputClassName || "").trim()}`}
          onChange={handleAddFile}
        />
        <small>
          Max 5MB per file
        </small>
      </div>

      {/* PROGRESS BAR */}
      {uploading && (
        <div className="progress mb-3">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${uploadProgress}%` }}
          >
            {uploadProgress}%
          </div>
        </div>
      )}

      <ShowPic
        open={showPreviewModal}
        onClose={() => {
          setShowPreviewModal(false);
          setPreviewFiles([]);
        }}
        row={{ catatan: "" }}
        backendPort={backendPort}
        token=""
        onUploadSuccess={() => {}}
        readOnly
        customFiles={previewFiles}
        customTitle="Preview Dokumen/Lampiran"
      />

    </div>
  );
}
